import { Crown } from 'lucide-react'

export default function ProBadge({ className = '', glow = true }) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full text-white flex-shrink-0 ${className}`}
      style={{
        background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
        ...(glow ? { boxShadow: '0 0 8px rgba(139,92,246,0.30)' } : {}),
      }}
    >
      <Crown size={9} strokeWidth={2.5} />
      PRO
    </span>
  )
}
